import { GET_DETAIL_CART, ADD_TO_CART, REMOVE_FROM_CART, DELETE_SERVICE_FROM_CART, APPLY_COUPON, ADD_TO_CART_FROM_RECOMMENDED } from '../actions/Types'
const initial_state = {
    cart:{},
    cart_detail: {}
}

const helper = (state, action) => {
    let newState = {cart: {}, cart_detail: {}}
    let subtotal = 0;

    Object.keys(action.payload).forEach(x => {
        if (x in state.cart){
            newState.cart[x] = {...state.cart[x], ...action.payload[x]}
            newState.cart[x]['total'] = action.payload[x]['quantity'] * action.payload[x]['price']
            newState.cart_detail = {}
        }
        subtotal += action.payload[x]['quantity'] * action.payload[x]['price']
        
    })

    if (state.cart_detail.category){
        let discount;
        if (state.cart_detail.discount_percent){
            discount = subtotal * state.cart_detail.discount_percent / 100
        }
        else{
            discount = state.cart_detail.discount
        }
        let tax = subtotal * 5 / 100
        const cart_total = (subtotal - discount + tax).toFixed(2)
        newState.cart_detail = {...state.cart_detail, ...{cart_subtotal: subtotal, tax: tax, total: cart_total, discount: discount}}
    }

    return newState
}
const getDetailCart = (state=initial_state, action) => {
    switch (action.type){
        case GET_DETAIL_CART:
            return {...state, ...action.payload}
        case ADD_TO_CART:
            let addState = helper(state, action)
            return addState
        case REMOVE_FROM_CART:
            let removeState = helper(state, action)
            return removeState
        case DELETE_SERVICE_FROM_CART:
            let deleteState = helper(state, action)
            return deleteState
        case APPLY_COUPON:
            return {...state, ...action.payload}
        case ADD_TO_CART_FROM_RECOMMENDED:
            const newstate = {cart: {...state.cart, ...action.payload.added}, cart_detail: action.payload.cart_detail}
            // const newstate = {cart: {...action.payload.added, ...state.cart}, cart_detail: action.payload.cart_detail}
            return newstate
        default:
            return state
    }
}

export default getDetailCart